module.exports = __webpack_public_path__ + "static/logo-dark-23da663284265321eb8b33b6db27c659.png";